//@ts-nocheck
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const localize_1 = require("./localize");
const contactForms = Array.from(document.querySelectorAll('[data-contact-form]'));
const contactFormGlnField = document.querySelector('#contactForm--text-6');
const glnLabel = document.querySelector('[for="contactForm--text-6"]');
const requiredSelectErrorText = (0, localize_1.Localize)('contactForm.error.requiredSelect');
const requiredEmailErrorText = (0, localize_1.Localize)('contactForm.error.email');
const requiredInputErrorText = (0, localize_1.Localize)('contactForm.error.requiredInput');
if (contactForms && contactFormTopics && contactFormGlnField) {
    contactForms.forEach((contactForm) => {
        // Add custom validation text
        for (const inputElement of contactForm.querySelectorAll("input[required],textarea")) {
            // Initial validation
            validateContactFormField(inputElement);
            inputElement.addEventListener('keyup', (event) => {
                validateContactFormField(inputElement);
            });
            inputElement.addEventListener('change', (event) => {
                validateContactFormField(inputElement);
            });
        }
        for (const selectElement of contactForm.querySelectorAll("select[required]")) {
            // Initial validation
            validateContactFormSelect(selectElement);
            selectElement.addEventListener('change', (event) => {
                validateContactFormSelect(selectElement);
            });
        }
        let topicsSelect = document.querySelector('#contactForm--singleselect-1');
        let subtopicsSelect = document.querySelector('#contactForm--singleselect-2');
        if (topicsSelect && subtopicsSelect) {
            // Reset topic select, it is filled with a placeholder value via forms editor
            topicsSelect.innerHTML = '';
            // Add mandatory asterisk to GLN field
            let mandatoryInfo = document.createElement('span');
            mandatoryInfo.innerHTML = ' *';
            mandatoryInfo.style.display = 'none';
            glnLabel.appendChild(mandatoryInfo);
            for (let topic in contactFormTopics) {
                let topicOption = new Option(contactFormTopics[topic].name, topic);
                topicsSelect.appendChild(topicOption);
            }
            topicsSelect.addEventListener('change', (event) => {
                event.preventDefault();
                // Clear subtopicsSelect options
                subtopicsSelect.innerHTML = '';
                let selectedTopic = topicsSelect.options[topicsSelect.selectedIndex].value;
                for (let subtopic in contactFormTopics[selectedTopic].subtopics) {
                    let subtopicOption = new Option(contactFormTopics[selectedTopic].subtopics[subtopic].name, subtopic);
                    subtopicsSelect.appendChild(subtopicOption);
                }
                let subEvent = new Event('change');
                subtopicsSelect.dispatchEvent(subEvent);
            });
            subtopicsSelect.addEventListener('change', (event) => {
                event.preventDefault();
                let selectedTopic = topicsSelect.options[topicsSelect.selectedIndex].value;
                if (subtopicsSelect.options[subtopicsSelect.selectedIndex]) {
                    let selectedSubTopic = subtopicsSelect.options[subtopicsSelect.selectedIndex].value;
                    mandatoryInfo.style.display = 'none';
                    contactFormGlnField.removeAttribute('required');
                    contactFormGlnField.removeEventListener('keyup', (event) => { });
                    contactFormGlnField.removeEventListener('change', (event) => { });
                    contactFormGlnField.setCustomValidity('');
                    if (contactFormTopics[selectedTopic].subtopics[selectedSubTopic].require_gln === true) {
                        mandatoryInfo.style.display = 'inline';
                        contactFormGlnField.setAttribute('required', 'required');
                        validateContactFormField(contactFormGlnField);
                        contactFormGlnField.addEventListener('keyup', (event) => {
                            validateContactFormField(contactFormGlnField);
                        });
                        contactFormGlnField.addEventListener('change', (event) => {
                            validateContactFormField(contactFormGlnField);
                        });
                    }
                }
            });
            const event = new Event('change');
            topicsSelect.dispatchEvent(event);
        }
    });
    function validateContactFormField(element) {
        if (element.validity.valueMissing) {
            element.setCustomValidity(requiredInputErrorText);
        }
        else {
            if (element.validity.patternMismatch) {
                element.setCustomValidity(requiredEmailErrorText);
            }
            else {
                element.setCustomValidity('');
            }
        }
    }
    function validateContactFormSelect(element) {
        if (element.selectedIndex > 0) {
            element.setCustomValidity('');
        }
        else {
            element.setCustomValidity(requiredSelectErrorText);
        }
    }
}
